import PropTypes from 'prop-types';

const ShieldSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M34.0167 11.6V16.3334L12.3334 32.2334L7.95007 28.95C6.86673 28.1334 5.9834 26.3834 5.9834 25.0334V11.6C5.9834 9.73336 7.41673 7.66669 9.16673 7.01669L18.2834 3.60002C19.2334 3.25002 20.7667 3.25002 21.7167 3.60002L30.8334 7.01669C32.5834 7.66669 34.0167 9.73336 34.0167 11.6Z"
        fill={color}
      />
      <path
        d="M34.0162 18.6167V25.0334C34.0162 26.3834 33.1329 28.1334 32.0495 28.95L22.9329 35.7667C22.1329 36.3667 21.0662 36.6667 19.9995 36.6667C18.9329 36.6667 17.8662 36.3667 17.0662 35.7667L13.8662 33.3834L34.0162 18.6167Z"
        fill={color}
      />
    </svg>
  );
};

ShieldSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ShieldSvg;
